<template>
  <div ref="animation" class="aha-lottie-player" />
</template>
<script>
import lottie from 'lottie-web'

export default {
  props: {
    animationData: { type: [Object, String], required: true },
    rendererSettings: { type: Object, required: false, default: null },
    loop: { type: [Boolean, Number], default: false },
    autoPlay: { type: Boolean, default: true },
    renderer: { type: String, default: 'svg' },
    speed: { type: Number, default: 1 },
  },
  data() {
    return {
      animation: null,
    }
  },
  watch: {
    animationData: function watchAnimationData() {
      this.init()
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      const settings = {
        container: this.$refs.animation,
        renderer: this.renderer,
        loop: this.loop,
        autoplay: this.autoPlay,
        animationData: this.animationData,
        rendererSettings: this.rendererSettings,
      }
      this.animation = lottie.loadAnimation(settings)
      this.animation.addEventListener('loopComplete', () => {
        this.$emit('loopComplete', this.animation)
      })
      this.animation.addEventListener('complete', () => {
        this.$emit('complete', this.animation)
      })
      this.animation.addEventListener('enterFrame', () => {
        this.$emit('enterFrame', this.animation)
      })
    },
    play() {
      if (this.animation) { this.animation.play() }
    },
    stop() {
      if (this.animation) { this.animation.stop() }
    },
    pause() {
      if (this.animation) { this.animation.pause() }
    },
  },
}
</script>
